import Loadable from '../../components/loadable';

const ConsentClausesList = Loadable({
  loader: () => import('react/pages/privacy_policies/consent_clauses_list'),
});

angular.module('gym').value('ConsentClausesList', ConsentClausesList);
